<template>
  <v-row class="pb-0 pt-4" id="files-table-section">
    <v-col cols="12">
      <div class="d-flex justify-space-between align-center mb-4">
        <h3>
          لیست فایل‌های آماده دانلود
          <v-btn
            icon
            class="btn-download border-2 rounded-pill"
            @click="fetchFiles"
            title="بروزرسانی لیست"
          >
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </h3>

        <div class="d-flex algin-center flex-warp" style="gap: 10px">
          <v-slide-x-transition>
            <div
              v-if="selectedFiles.length > 0"
              class="d-flex"
              style="gap: 8px"
            >
              <v-btn class="btn-delete rounded-lg" @click="bulkDelete">
                <v-icon small right class="pr-2">mdi-trash-can</v-icon> حذف
                پوشه/ فایل ({{ selectedFiles.length }})
              </v-btn>

              <v-btn
                v-if="downloadableSelectedFiles.length > 0"
                class="btn-get-code rounded-lg"
                @click="bulkDownload"
              >
                <v-icon small right class="pr-2">mdi-download</v-icon> دانلود
                فایل ({{ downloadableSelectedFiles.length }})
              </v-btn>
            </div>
          </v-slide-x-transition>
          <v-btn-toggle
            v-model="viewMode"
            mandatory
            class="rounded-lg"
            color="primary"
          >
            <v-btn value="table" title="نمایش جدولی">
              <v-icon>mdi-table</v-icon>
            </v-btn>
            <v-btn value="explorer" title="نمایش پوشه‌ای">
              <v-icon>mdi-view-grid</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>

      <div v-if="currentDirectory" class="mb-4 d-flex align-center" dir="ltr">
        <v-btn
          icon
          class="btn-delete rounded-pill"
          @click="goUpDirectory"
          title="بازگشت"
        >
          <v-icon small>mdi-arrow-up</v-icon>
        </v-btn>
        <span class="text-h6 text-muted">{{ currentDirectory }}</span>
      </div>

      <!-- حالت جدولی -->
      <div v-show="viewMode === 'table'">
        <v-data-table
          :items="displayItems"
          :headers="tableHeaders"
          :loading="isFetchingFiles"
          class="elevation-1 text-center"
          no-data-text="هیچ فایلی برای دانلود یافت نشد."
          disable-pagination
          hide-default-footer
        >
          <template v-slot:header.index="{ header }">
            <div class="d-flex align-center justify-center">
              <v-checkbox
                :input-value="isAllSelected"
                :indeterminate="isSomeSelected"
                @click.stop="toggleSelectAll"
                color="primary"
                hide-details
                class="ma-0 pa-0 d-inline-block mr-2"
              ></v-checkbox>
              {{ header.text }}
            </div>
          </template>
          <template v-slot:item.index="{ item, index }">
            <div class="d-flex align-center justify-center">
              <v-checkbox
                :input-value="isSelected(item)"
                @click.stop="toggleSelection(item)"
                hide-details
                class="ma-0 pa-0 d-inline-block mr-2"
              ></v-checkbox>
              {{ index + 1 }}
            </div>
          </template>

          <template v-slot:item.name="{ item }">
            <div
              class="d-flex align-center cursor-pointer"
              @click="item.isDir ? openDirectory(item.name) : null"
              dir="ltr"
            >
              <v-icon class="mr-2" :color="item.isDir ? 'warning' : 'primary'">
                {{ item.isDir ? "mdi-folder" : "mdi-image" }}
              </v-icon>
              <span>{{ item.name }}</span>
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <template v-if="!item.isDir">
              <manageButton :data="item" :meta="metaButtons" />
            </template>
            <template v-else>
              <manageButton :data="item" :meta="metaButtonsFolder" />
            </template>
          </template>
        </v-data-table>
      </div>

      <!-- حالت پوشه ای -->
      <div v-show="viewMode === 'explorer'" class="explorer-container">
        <div
          v-if="displayItems.length > 0"
          class="d-flex align-center mb-4 px-2"
        >
          <v-checkbox
            :input-value="isAllSelected"
            :indeterminate="isSomeSelected"
            @click.stop="toggleSelectAll"
            color="primary"
            hide-details
            class="ma-0 pa-0 mr-2"
          ></v-checkbox>
          <span
            class="font-weight-bold cursor-pointer"
            style="font-size: 14px"
            @click="toggleSelectAll"
          >
            انتخاب همه فایل‌ها و پوشه‌ها
          </span>
        </div>
        <v-row v-if="displayItems.length > 0">
          <v-col
            v-for="(item, index) in displayItems"
            :key="index"
            cols="6"
            sm="4"
            md="3"
            lg="2"
          >
            <v-card
              class="file-card text-center pa-3 rounded-lg"
              :class="{ 'selected-card': isSelected(item) }"
              @click="
                item.isDir ? openDirectory(item.name) : toggleSelection(item)
              "
              hover
              outlined
            >
              <div
                class="d-flex justify-space-between align-start"
                style="height: 24px; gap: 2px; width: 100%"
              >
                <!-- چک‌باکس برای فایل‌ها و پوشه‌ها -->
                <div style="min-width: 24px">
                  <v-checkbox
                    :input-value="isSelected(item)"
                    hide-details
                    color="primary"
                    class="ma-0 pa-0"
                    @click.stop="toggleSelection(item)"
                  ></v-checkbox>
                </div>

                <div class="d-flex justify-end flex-grow-1" style="gap: 5px">
                  <!-- دکمه دانلود برای پوشه‌ها -->
                  <v-btn
                    v-if="item.isDir"
                    icon
                    small
                    color="success"
                    @click.stop="downloadFolder(item)"
                    title="دانلود پوشه"
                  >
                    <v-icon small>mdi-download</v-icon>
                  </v-btn>

                  <!-- دکمه حذف برای فایل‌ها و پوشه‌ها -->
                  <v-btn
                    v-if="item.isDir"
                    icon
                    small
                    color="error"
                    @click.stop="
                      item.isDir ? deleteFolder(item) : deleteFile(item)
                    "
                    :title="item.isDir ? 'حذف پوشه' : 'حذف فایل'"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                  <template v-if="!item.isDir">
                    <manageButtonVertical :data="item" :meta="metaButtons" />
                  </template>
                </div>
              </div>

              <v-icon
                size="64"
                :color="
                  item.isDir
                    ? 'warning'
                    : isSelected(item)
                    ? 'primary'
                    : 'grey darken-1'
                "
                class="my-2"
              >
                {{ item.isDir ? "mdi-folder" : "mdi-file-image" }}
              </v-icon>

              <div
                class="file-name text-truncate mt-1"
                dir="ltr"
                :title="item.name"
                style="font-size: 13px; text-align: center"
              >
                {{ item.name }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card
          v-else
          flat
          class="text-center pa-10"
          style="border: 1px dashed #ccc"
        >
          <v-icon size="50" color="grey">mdi-folder-open-outline</v-icon>
          <p class="mt-4 text-muted">هیچ فایلی در این مسیر یافت نشد.</p>
        </v-card>
      </div>
    </v-col>
    <!-- اضافه شدن دیالوگ برای کامپوننت تبدیل فرمت -->
    <custom-popup
      v-model="convertDialog"
      :cons="{ title: 'تبدیل فرمت و دانلود فایل' }"
      hide-confirm
      max-width="600"
    >
      <v-card class="rounded-lg">
        <v-card-text class="pt-6">
          <download-file_nfc
            v-if="convertDialog && fileToConvertInfo"
            :info="fileToConvertInfo"
            :visit-name="fileToConvertName"
          />
        </v-card-text>
      </v-card>
    </custom-popup>
  </v-row>
</template>

<script>
import manageButton from "@/view/pages/button";
import manageButtonVertical from "@/view/pages/VerticalButtons";
import downloadFile_nfc from "../../qrland/downloadFile_nfc.vue";

export default {
  name: "NfcFileManager",
  components: { manageButton, manageButtonVertical, downloadFile_nfc },
  data() {
    return {
      convertDialog: false,
      fileToConvertInfo: null,
      fileToConvertName: "",
      viewMode: "table",
      selectedFiles: [],
      isFetchingFiles: false,
      explorerPath: "",
      rawFilesList: [],
      currentDirectory: "",
      tableHeaders: [
        { text: "ردیف", value: "index", align: "center", sortable: false },
        { text: "نام پوشه/ فایل", value: "name", align: "center" },
        { text: "عملیات", value: "actions", align: "center", sortable: false },
      ],
      metaButtonsFolder: {
        buttons: [
          {
            name: "downloadFolder",
            label: "دانلود پوشه",
            icon: "download",
            class: "btn-outline-success border-2 rounded-pill",
            action: this.downloadFolder,
            status: "phoneBook_show",
          },
          {
            name: "deleteFolder",
            label: "حذف پوشه",
            icon: "trash",
            class: "btn-outline-danger border-2 rounded-pill",
            action: this.deleteFolder,
            status: "phoneBook_show",
          },
        ],
      },
      metaButtons: {
        buttons: [
          {
            name: "convert",
            label: "تبدیل و دانلود",
            icon: "sync",
            class: "btn-outline-primary border-2 rounded-pill",
            action: this.openConvertDialog,
            status: "phoneBook_show",
          },
          {
            name: "download",
            label: "دانلود",
            icon: "download",
            class: "btn-outline-success border-2 rounded-pill",
            action: this.downloadFile,
            status: "phoneBook_show",
          },
          {
            name: "delete",
            label: "حذف از سرور",
            icon: "trash",
            class: "btn-outline-danger border-2 rounded-pill",
            action: this.deleteFile,
            status: "phoneBook_show",
          },
        ],
      },
    };
  },
  computed: {
    isAllSelected() {
      if (this.displayItems.length === 0) return false;
      return this.displayItems.every((item) => this.isSelected(item));
    },
    isSomeSelected() {
      if (this.displayItems.length === 0) return false;
      const selectedCount = this.displayItems.filter((item) =>
        this.isSelected(item),
      ).length;
      return selectedCount > 0 && selectedCount < this.displayItems.length;
    },
    displayItems() {
      const items = [];
      const folders = new Set();
      this.rawFilesList.forEach((path) => {
        const prefix = this.currentDirectory ? this.currentDirectory + "/" : "";
        if (path.startsWith(prefix)) {
          const relativePath = path.substring(prefix.length);
          if (relativePath.includes("/")) {
            const folderName = relativePath.split("/")[0];
            folders.add(folderName);
          } else if (relativePath) {
            items.push({ name: relativePath, path: path, isDir: false });
          }
        }
      });
      folders.forEach((folder) => {
        items.push({
          name: folder,
          path:
            (this.currentDirectory ? this.currentDirectory + "/" : "") + folder,
          isDir: true,
        });
      });
      return items.sort((a, b) => {
        if (a.isDir && !b.isDir) return -1;
        if (!a.isDir && b.isDir) return 1;
        return a.name.localeCompare(b.name);
      });
    },
    downloadableSelectedFiles() {
      return this.selectedFiles.filter((item) => !item.isDir);
    },
  },
  mounted() {
    this.fetchFiles();
  },
  methods: {
    openConvertDialog(fileObj) {
      console.log(fileObj, "obj");
      const extension = fileObj.name.split(".").pop().toLowerCase();
      if (extension !== "svg") {
        this.$toast.warning(
          "قابلیت تغییر فرمت فقط برای فایل‌های SVG در دسترس است.",
        );
        return;
      }
      this.fileToConvertName = fileObj.name.replace(/\.[^/.]+$/, "");

      this.fileToConvertInfo = {
        img_url: "/nfc/" + fileObj.path,
        image: "/nfc/" + fileObj.path,
      };

      this.convertDialog = true;
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        const currentPaths = this.displayItems.map((item) => item.path);
        this.selectedFiles = this.selectedFiles.filter(
          (f) => !currentPaths.includes(f.path),
        );
      } else {
        const itemsToAdd = this.displayItems.filter(
          (item) => !this.isSelected(item),
        );
        this.selectedFiles = [...this.selectedFiles, ...itemsToAdd];
      }
    },
    openDirectory(dirName) {
      this.currentDirectory = this.currentDirectory
        ? this.currentDirectory + "/" + dirName
        : dirName;
      this.selectedFiles = [];
    },
    goUpDirectory() {
      if (!this.currentDirectory) return;
      const parts = this.currentDirectory.split("/");
      parts.pop();
      this.currentDirectory = parts.join("/");
      this.selectedFiles = [];
    },
    toggleSelection(item) {
      const filePath = item.path;
      if (this.isSelected(item)) {
        this.selectedFiles = this.selectedFiles.filter(
          (f) => f.path !== filePath,
        );
      } else {
        this.selectedFiles.push(item);
      }
    },
    isSelected(item) {
      return this.selectedFiles.some((f) => f.path === item.path);
    },
    fetchFiles() {
      this.isFetchingFiles = true;
      this.selectedFiles = [];
      this.currentDirectory = "";
      this.$api
        .get(`/admin/nfc/explorer`)
        .then((res) => {
          this.rawFilesList = res.data.data || res.data || [];
        })
        .finally(() => {
          this.isFetchingFiles = false;
        });
    },
    bulkDownload() {
      const filesToDownload = this.downloadableSelectedFiles;
      if (filesToDownload.length === 0) return;

      const filePaths = filesToDownload.map((f) => f.path);
      const payload = { files: filePaths, directory: this.explorerPath };

      this.$api
        .post("/admin/nfc/explorer/files", payload)
        .then((res) => {
          if (res.data && res.data.status && res.data.data) {
            const downloadUrl = res.data.data.replace("/api/", "/");
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$toast.success("دانلود گروهی با موفقیت انجام شد.");
          } else {
            this.$toast.error("لینک دانلود از سمت سرور دریافت نشد.");
          }
        })
        .catch(() => this.$toast.error("خطا در دانلود گروهی فایل‌ها"));
    },
    bulkDelete() {
      if (this.selectedFiles.length === 0) return;
      const filePaths = this.selectedFiles.map((f) => f.path);

      this.$modal
        .yesNo(
          `آیا از حذف ${this.selectedFiles.length} آیتم (فایل/پوشه) اطمینان دارید؟`,
        )
        .then((value) => {
          if (value) {
            this.$api
              .post("admin/nfc/explorer/delete", { paths: filePaths })
              .then(() => {
                this.$toast.success("آیتم‌های انتخاب شده حذف شدند.");
                this.fetchFiles();
              })
              .catch(() => this.$toast.error("خطا در حذف آیتم‌ها"));
          }
        });
    },
    downloadFile(fileObj) {
      const explorer =
        this.explorerPath.trim() === "" ? null : this.explorerPath;

      this.$api
        .post("/admin/nfc/explorer/files", {
          files: [fileObj.path],
          directory: explorer,
        })
        .then((res) => {
          if (res.data && res.data.status && res.data.data) {
            const downloadUrl = res.data.data.replace("/api/", "/");
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            this.$toast.error("لینک دانلود دریافت نشد.");
          }
        })
        .catch(() => this.$toast.error("خطا در دانلود فایل"));
    },
    // متد جدید اضافه شده برای دانلود پوشه
    downloadFolder(folderObj) {
      this.$api
        .post("/admin/nfc/explorer/files", {
          files: "*",
          directory: folderObj.path,
        })
        .then((res) => {
          if (res.data && res.data.status && res.data.data) {
            const downloadUrl = res.data.data.replace("/api/", "/");
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            this.$toast.error("لینک دانلود پوشه دریافت نشد.");
          }
        })
        .catch(() => this.$toast.error("خطا در دانلود پوشه"));
    },
    deleteFolder(folderObj) {
      this.$modal
        .yesNo(
          `آیا از حذف کامل پوشه "${folderObj.name}" و تمام فایل‌های داخل آن اطمینان دارید؟`,
        )
        .then((value) => {
          if (value) {
            this.$api
              .post("admin/nfc/explorer/delete", { paths: [folderObj.path] })
              .then(() => {
                this.$toast.success("پوشه با موفقیت حذف شد.");
                this.fetchFiles();
              })
              .catch(() => this.$toast.error("خطا در حذف پوشه"));
          }
        });
    },
  },
};
</script>

<style scoped>
.file-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid transparent;
}
.file-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  border-color: #e0e0e0;
}
.selected-card {
  background-color: #f0f7ff !important;
  border: 1px solid #1976d2 !important;
}
.file-name {
  color: #333;
  font-weight: 500;
}
</style>
